import { forwardRef } from "react";
import { byIdentifier } from "@minohealth/common/utils/ids";
import ChatImageViewerBase from "./ChatImageViewerBase";
import { useChatContext } from "@/services/chat-provider";

const ChatImageViewer = forwardRef(({ srcImageId, bboxes, multiple = false, onCloseViewer, onGenerateReport, showGenerateReportBtn }, ref) => {
  const { useActiveChatSessionImages } = useChatContext()

  const { data: chatImages } = useActiveChatSessionImages();
  const image = chatImages?.find(byIdentifier(srcImageId));

  return (
    <ChatImageViewerBase
      srcImage={image}
      bboxes={bboxes}
      multiple={multiple}
      onCloseViewer={onCloseViewer}
      onGenerateReport={onGenerateReport}
      showGenerateReportBtn={showGenerateReportBtn}
      ref={ref}
    />
  );
});

export default ChatImageViewer;
